import { render, staticRenderFns } from "./SkewedSeparator.vue?vue&type=template&id=a4cafb44&"
import script from "./SkewedSeparator.vue?vue&type=script&lang=js&"
export * from "./SkewedSeparator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports